<script setup lang="ts">
import { useDebounceFn } from "@vueuse/core";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import InputText from "primevue/inputtext";
import Filters from "@/components/OperationsApp/components/Filters/index.vue";
import PriceOverrideHeader from "@/components/OperationsApp/components/PriceOverrideHeader/index.vue";
import PriceOverrideTable from "@/components/OperationsApp/components/PriceOverrideTable/index.vue";
import { useQFilter } from "@/components/OperationsApp/composables/useQFilter.ts";
import { priceOverridePresets } from "./styles.ts";
import type { Props } from "./types.ts";

defineOptions({
  name: "PriceOverride",
});

const props = withDefaults(defineProps<Props>(), {});

const { q, updateQFilter } = useQFilter();

const debouncedQUpdate = useDebounceFn(
  (value) => {
    updateQFilter(value);
  },
  1000,
  { maxWait: 5000 },
);
</script>

<template>
  <div class="mt-6 mx-6">

    <PriceOverrideHeader  />
    <div class="flex font-normal font-montserrat w-full mt-6 justify-end">
      <IconField iconPosition="left" class="w-2/4 pr-2">
        <InputIcon class="input-icon-position">
          <span class="material-symbols-outlined text-green-800 text-center text-3xl ml-4">search</span>
        </InputIcon>
        <InputText
          :pt="priceOverridePresets.inputtext"
          :model-value="q"
          placeholder="SEARCH"
          @update:modelValue="value => debouncedQUpdate(value)"
          class="ml-4 w-full block font-montserrat font-bold text-base text-university-primary leading-5 py-1 pr-1 border border-gray-475 rounded-full h-10 placeholder-university-primary bg-white" />
      </IconField>
    </div>
    <Filters />
    <PriceOverrideTable />
  </div>
</template>

<style scoped>
.input-icon-position {
  top: 12px;
}
</style>
